<template lang="pug">
//- 首頁
.home-index.page-index
  homeHeader
  homeBanner
  homeEdu
  homeVideo
  homeFooter

  //- 懸浮廣告視窗
  .floating-ad-overlay(v-if="showFloatingAd" @click="closeFloatingAd")
    .floating-ad-container(@click.stop)
      .floating-ad-content
        img.floating-ad-image(:src="$root.full_ad_image_uri" @click="openFloatingAdLink")
        .countdown-display(v-if="countdown > 0")
          span.countdown-text {{ countdown }}s
        .floating-ad-close-btn(
          v-if="countdown <= 0"
          @click="closeFloatingAd"
        )
          span.close-icon ×
</template>
<script>
// import $ from 'jquery'
import homeHeader from '@/components/header'
import homeBanner from '@/components/home/home-banner'
import homeEdu from '@/components/home/home-edu'
import homeVideo from '@/components/home/home-video'
import homeFooter from '@/components/footer'


export default {
  name: 'Index',
  components: {
    homeHeader,
    homeBanner,
    homeEdu,
    homeVideo,
    homeFooter,
  },
  data () {
    return {
      showFloatingAd: false,
      countdown: 5,
      countdownTimer: null,
    };
  },
  async created () {
    this.$root.closeLoading()
    this.getTopBannerInfo()
  },
  destroyed () {

  },
  mounted () {

  },
  computed: {
  },
  methods: {
    // 獲得懸浮廣告資訊
    getTopBannerInfo () {
      let vm = this
      this.$root.apis.getBannerInfo(2, 'website', function (_response) {
        let images = _response.body
        if (images.length > 0) {
          vm.$root.full_ad_image_uri = images[0].image
          vm.$root.show_full_ad_view = true
          // 顯示懸浮廣告
          vm.openFloatingAd()
        }
      }, this.processStatusError)
    },
    // 開啟懸浮廣告視窗
    openFloatingAd () {
      console.log('--> 顯示懸浮廣告:', this.$root.full_ad_image_uri)
      this.showFloatingAd = true
      this.countdown = 5 // 設置倒數計時為5秒
      this.startCountdown()

      // 等待圖片加載完成後調整容器尺寸
      this.$nextTick(() => {
        this.adjustContainerSize()
      })
    },
    // 調整容器尺寸以適應圖片比例
    adjustContainerSize () {
      const img = new Image()
      img.onload = () => {
        const imgRatio = img.width / img.height
        const maxWidth = window.innerWidth * 0.9
        const maxHeight = window.innerHeight * 0.75

        let containerWidth, containerHeight

        if (imgRatio > maxWidth / maxHeight) {
          // 圖片較寬，以寬度為準
          containerWidth = maxWidth
          containerHeight = maxWidth / imgRatio
        } else {
          // 圖片較高，以高度為準
          containerHeight = maxHeight
          containerWidth = maxHeight * imgRatio
        }

        // 設置容器尺寸
        const container = document.querySelector('.floating-ad-container')
        if (container) {
          container.style.width = containerWidth + 'px'
          container.style.height = containerHeight + 'px'
        }
      }
      img.src = this.$root.full_ad_image_uri
    },
    // 開始倒數計時
    startCountdown () {
      // 清除之前的計時器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },
    // 關閉懸浮廣告視窗
    closeFloatingAd () {
      if (this.countdown > 0) {
        return // 如果倒數還沒結束，不允許關閉
      }

      this.showFloatingAd = false
      this.countdown = 5

      // 清除計時器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    // 開啟懸浮廣告連結
    openFloatingAdLink () {
      console.log('--> 開啟懸浮廣告連結')
      // 這裡可以實現開啟連結的邏輯
      // 例如：window.open(this.floatingAdLink, '_blank')
    },
    // 處理 API 錯誤
    processStatusError (_error) {
      console.error('--> API 錯誤:', _error)
    }
  }
}
</script>
<style lang="css">
/* 懸浮廣告樣式 */
.floating-ad-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

.floating-ad-container {
  position: relative;
  max-width: 90vw;
  max-height: 75vh;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: slideIn 0.3s ease-out;
}

.floating-ad-content {
  position: relative;
  display: flex;
  flex-direction: column;
}

.floating-ad-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.floating-ad-image:hover {
  transform: scale(1.02);
}

.floating-ad-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.floating-ad-close-btn:hover:not(.disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.floating-ad-close-btn.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.close-icon {
  font-size: 20px;
  line-height: 1;
}

/* 倒數計時顯示 */
.countdown-display {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.countdown-text {
  font-size: 14px;
  line-height: 1;
  font-weight: bold;
}

/* 動畫效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: scale(0.8) translateY(-20px);
    opacity: 0;
  }

  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

/* 響應式設計 */
@media (max-width: 768px) {
  .floating-ad-container {
    max-width: 95vw;
    max-height: 75vh;
  }

  .floating-ad-close-btn {
    width: 35px;
    height: 35px;
    top: 8px;
    right: 8px;
  }

  .countdown-display {
    width: 35px;
    height: 35px;
    top: 8px;
    right: 8px;
  }

  .close-icon {
    font-size: 16px;
  }

  .countdown-text {
    font-size: 12px;
  }
}
</style>
